/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const DayWrapOuter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30px;
  padding-top: 4px;
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 12px;
  color: ${Palette.PrimaryGray._400};
  border-top: 1px solid transparent;
  user-select: none;
`;

export const DayWrapInner = styled.div`
  position: relative;
  width: 0px;
  overflow: visible;
`;

export const Day = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: fit-content;
  transform: translateX(-50%);
`;

export const Body = styled.div`
  position: relative;
  width: 100%;

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    background-image: linear-gradient(${Palette.Primary._500} 50%, rgba(255, 255, 255, 0) 0%);
    background-position: right;
    background-size: 1px 8px;
    background-repeat: repeat-y;
    opacity: 0;
  }
`;

export const IconsWrap = styled.div`
  width: 100%;
  height: 24px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoIconWrap = styled.div`
  position: absolute;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  background-color: white;
  border-radius: 50%;
`;

export const NotesIconWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Point = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  border-radius: 4px;
  width: 8px;
  height: 8px;
  background-color: ${Palette.Violet._100};
  border-style: solid;
  border-width: 2px;
  z-index: 2;
  opacity: 0;
`;

export const TooltipWrap = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ tooltipPlacement }) => (tooltipPlacement === 'left' ? '50%' : 'unset')};
  right: ${({ tooltipPlacement }) => (tooltipPlacement === 'right' ? '50%' : 'unset')};
  transform: ${({ tooltipPlacement }) =>
    tooltipPlacement === 'left' ? 'translate(8px, -50%)' : 'translate(-8px, -50%)'};
  z-index: 20;
  pointer-events: none;
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  z-index: 10;

  &:hover {
    z-index: 999;
  }

  &.sibling-hover ${DayWrapOuter} {
    opacity: 0 !important;
  }

  &:hover ${DayWrapOuter} {
    color: ${Palette.Primary._500};
    border-top: 1px solid ${Palette.Primary._500};
    opacity: 1 !important;
  }

  &:hover ${Body}::before {
    opacity: 1;
  }
  &:hover ${Point} {
    opacity: 1;
  }
  &:hover ${InfoIconWrap} {
    display: flex;
  }
  &:hover ${NotesIconWrap} {
    display: none;
  }
`;
